export default __webpack_public_path__ + "static/media/PaintingTheLoft_08.e0cd70ee.png";